module.exports = "<div class=\"app\">\n  <app-toolbar *ngIf=\"strCurrentPageName !== arrStrPageListTargeted[2] && bIsPageLoad\"></app-toolbar>\n  <app-navbar *ngIf=\"strCurrentPageName !== arrStrPageListTargeted[2] && bIsPageLoad\"></app-navbar>\n  <spinner-component></spinner-component>\n  <router-outlet></router-outlet>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main